import { render, staticRenderFns } from "./ChargInfo.vue?vue&type=template&id=72962088&scoped=true&"
import script from "./ChargInfo.vue?vue&type=script&lang=js&"
export * from "./ChargInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChargInfo.vue?vue&type=style&index=0&id=72962088&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72962088",
  null
  
)

export default component.exports